interface SupabaseIconProps {
  size?: number;
  /** Whether to show the rounded square background (used in header & auth hero). */
  withBackground?: boolean;
  className?: string;
}

/**
 * Supabase brand icon.
 *
 * Usage:
 *   <SupabaseIcon size={20} withBackground />   — header chip
 *   <SupabaseIcon size={96} withBackground />   — auth hero
 *   <SupabaseIcon size={12} />                  — inline hint text
 */
export function SupabaseIcon({ size = 20, withBackground = false, className }: SupabaseIconProps) {
  // Each instance needs unique gradient/clip IDs so multiple icons on the same
  // page don't share defs and produce render glitches.
  const uid = `sb-${size}-${withBackground ? 'bg' : 'no'}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {withBackground && <rect width="96" height="96" rx="12" fill="white" fillOpacity="0.2" />}
      <g clipPath={`url(#${uid}-clip)`}>
        <path
          d="M53.2589 78.936C51.6254 80.9945 48.3069 79.867 48.2704 77.2375L47.6924 38.7845H73.5499C78.2324 38.7845 80.8434 44.193 77.9314 47.859L53.2589 78.936Z"
          fill={`url(#${uid}-grad0)`}
        />
        <path
          d="M53.2589 78.936C51.6254 80.9945 48.3069 79.867 48.2704 77.2375L47.6924 38.7845H73.5499C78.2324 38.7845 80.8434 44.193 77.9314 47.859L53.2589 78.936Z"
          fill={`url(#${uid}-grad1)`}
          fillOpacity="0.2"
        />
        <path
          d="M42.7421 17.064C44.3756 15.0055 47.6946 16.133 47.7306 18.762L47.9846 57.2155H22.4511C17.7686 57.2155 15.1576 51.807 18.0691 48.141L42.7421 17.064Z"
          fill="#3ECF8E"
        />
      </g>
      <defs>
        <linearGradient
          id={`${uid}-grad0`}
          x1="47.6947"
          y1="47.3131"
          x2="70.6748"
          y2="56.9508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249361" />
          <stop offset="1" stopColor="#3ECF8E" />
        </linearGradient>
        <linearGradient
          id={`${uid}-grad1`}
          x1="37.5064"
          y1="33.3635"
          x2="47.9863"
          y2="53.0923"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <clipPath id={`${uid}-clip`}>
          <rect width="64" height="64" fill="white" transform="translate(16 16)" />
        </clipPath>
      </defs>
    </svg>
  );
}
